/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Standings_VisibilityInputs */



/**
* | output |
* | --- |
* | "Standings Visibility" |
*
* @param {Tfield_Standings_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_standings_visibility = /** @type {((inputs?: Tfield_Standings_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Standings_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visibilité des classements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visibilidad de clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visibilidade das Classificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibilità Classifiche")
	return /** @type {LocalizedString} */ ("Standings Visibility")
});